export default __webpack_public_path__ + "static/media/ITBaby.cf8d7dd4.gif";